// React
import React from 'react';
import { Card, Col, Container, Row } from 'reactstrap';

// Containers Injections
import {
  PageWrapper,
  FloatButton,
  LoadingScreen,
  DropdownDatatable,
} from '../../containers/componentsInjection';

export const ProposalsListPage = ({
  id,
  loading,
  columns,
  history,
  handleEdit,
  handleDelete,
  proposalsAssociates,
}) => {
  return (
    <LoadingScreen loading={loading} titleMetaTag={'Propostas'}>
      <PageWrapper
        title={`Propostas de ${
          proposalsAssociates ? proposalsAssociates.name : ''
        }`}
      >
        <Row>
          <Col xs={12}>
            <div id="table-gridjs">
              <Card>
                <DropdownDatatable
                  pagination
                  persistTableHead
                  columns={columns}
                  keysSearch={['number']}
                  data={proposalsAssociates ? proposalsAssociates.data : []}
                  perPage={10}
                  actions={[
                    {
                      id: 1,
                      name: 'edit',
                      label: 'Editar',
                      onPress: (cellProps) => handleEdit(cellProps),
                      icon: 'la-pen',
                      classNameColorIcon: 'primary',
                    },
                  ]}
                  handleDelete={(cellProps) => handleDelete(cellProps)}
                />
              </Card>
            </div>
          </Col>
        </Row>
        <FloatButton
          handleButton={() => history.push(`/propostas/novo?customer=${id}`)}
        />
      </PageWrapper>
    </LoadingScreen>
  );
};
